import React, { useEffect, useRef } from 'react'
import classes from './style.module.scss'
import useStyles from 'isomorphic-style-loader/useStyles'
import ReactPlayer from 'react-player'
import { Iconfont } from '../../../../../../components/icon/iconfont'

export default props => {
    useStyles(classes)
    const { video, endedHandle, shouldPlay, clickHandle, muted, setMuted, isDetails } = props
    const [playing, setPlaying] = React.useState(shouldPlay)

    useEffect(() => {
        setPlaying(shouldPlay)
    }, [shouldPlay])

    const videoRef = useRef(null)

    const onEnded = () => {
        if (videoRef.current) {
            // videoRef.current.player.seekTo(0)
            // console.log(videoRef.current.player.pauseVideo)
            // videoRef.current.player.showPreview()
        }


        endedHandle()
    }

    const innerClickHandle = e => {
        // setMuted(true)
        clickHandle?.(e)
        if(isDetails){
            setPlaying(!playing)
        }
    }

    return <div className={classes.Video} onClick={innerClickHandle}>
        <ReactPlayer
            className={classes.Player}
            width='100%'
            height='100%'
            url={`https://www.youtube.com/watch?v=${video.youtubeId}`}
            muted={!!muted}
            playing={playing}
            ref={videoRef}
            light={!shouldPlay}
            stopOnUnmount
            config={{
                youtube: {
                    playerVars: { showinfo: 0, controls: 0, modestbranding: 1, playsinline: 1, autohide: 1, rel: 0, iv_load_policy: 3 },
                    embedOptions: { showinfo: 0, controls: 0, modestbranding: 1, playsinline: 1, autohide: 1, rel: 0, iv_load_policy: 3 }
                }
            }}
            onEnded={onEnded}
        />

        {
            isDetails && <span onClick={e => {
                e.stopPropagation()
                e.preventDefault()
                setMuted(!muted)
            }} className={`${classes.YoutubeMuted} ${!muted ? classes.Active : ''}`} />
        }

        {/* {
            !shouldPlay && <span className={`${classes.Play} ${!muted ? classes.Active : ''}`}>
                <Iconfont className={classes.Icon}>&#xe758;</Iconfont>
            </span>
        } */}
    </div>
}